import {ContactLink, ContainerGrow} from "./Documentation.css";
import React from "react";
import { Link } from "react-router-dom";

const Sandbox = () =>{
    return (
        <div className={ContainerGrow}>
            <p>Pour réaliser vos développement, un environnement "sandbox" est mis à disposition.</p>
            <p>Pour l'utiliser, vous devez vous enrôler via notre API Register, et être accrédité par l'une des autorités compétentes nationales européennes.</p>
            <p>Un identifiant et le mot de passe de l'utilisateur de test vous seront fournis en réponse à votre <Link className={ContactLink} to={"/home/contact"}>demande de
                contact</Link></p>
            <br/>
            <p>Sandbox URL : dev-api.ccmdirect.fr</p>
        </div>
    )
}

export default Sandbox;